import { useQuery } from '@tanstack/react-query';

import { providerService } from '@/services/provider-service';
import type { Feature } from '@/types/core/provider';
import type { UUID } from '@/utils/uuid';

import { providerQueryKeys } from './query-keys';

/**
 * Hook to find a specific provider feature by ID.
 */
export function useFindProviderFeature(
  tenantId?: UUID,
  providerId?: UUID,
  featureId?: UUID
) {
  return useQuery<Feature | null, Error>({
    queryKey: providerQueryKeys.featureDetail(tenantId, providerId, featureId),
    queryFn: async () => {
      if (!tenantId) throw new Error('Missing tenant id');
      if (!providerId) throw new Error('Missing provider id');
      if (!featureId) throw new Error('Missing feature id');

      const feature = await providerService.findProviderFeature(
        tenantId,
        providerId,
        featureId
      );
      return feature ?? null;
    },
    enabled: !!tenantId && !!providerId && !!featureId,
  });
}
